/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {ColumnProps} from 'components/StickyHeadTable/StickyHeadTable';
import GqlTableController from 'controllers/GqlTableController/GqlTableController';
import {GET_DAYS_TO_EXPIRE} from 'graphql/absences/Querys';
import {useTranslation} from 'react-i18next';
import ViewTitle from 'viewComponents/ViewTitle/ViewTitle';
import {LeaveRequest} from 'models/leaveRequest';
import './PalowansWithDaysToExpireTable.scss';
import {formatDateByLocale} from 'commons/formatDate';

const PalowansWithDaysToExpireTable: React.FC = () => {
  const {t, i18n} = useTranslation();
  const columns: ColumnProps[] = [
    {
      id: 'firstName',
      label: t('leaves.PalowansWithDaysToExpireTable.palowan_name'),
      render: (_: string, row: any) => `${row?.firstName} ${row?.lastName}`,
    },
    {
      id: 'daysToExpire',
      label: t('leaves.PalowansWithDaysToExpireTable.days_to_expire'),
    },
    {
      id: 'date',
      label: t('leaves.PalowansWithDaysToExpireTable.expire_date'),
      render: (value: string) =>
        formatDateByLocale(value, i18n.language as 'en' | 'es' | 'fr' | 'pt'),
    },
  ];

  const mapData = (data: LeaveRequest) => {
    return {
      ...data,
      dates_of_leave: `${data.startDate} - ${data.endDate}`,
      request_date: data.createdAt,
      type_of_absence: data.typeOfLeave?.description,
      days_of_leave: data.daysOff,
    };
  };

  return (
    <div className="PalowansWithDaysToExpireTable w-full flex flex-col flex-wrap pt-12">
      <ViewTitle>{t('leaves.PalowansWithDaysToExpireTable.title')}</ViewTitle>
      <GqlTableController
        columns={columns}
        placeholder={t('common.empty_list')}
        mapData={mapData}
        queryConfiguration={{
          query: GET_DAYS_TO_EXPIRE,
          rootField: 'daysToExpireList',
          queryVariables: (page, size) => ({
            pageParams: {
              page,
              size,
            },
          }),
        }}
      />
    </div>
  );
};

export default PalowansWithDaysToExpireTable;
